module.exports = __webpack_public_path__ + "static/media/Akemi_6042.60c3a9f4.jpg";